module.exports = __webpack_public_path__ + "static/smarthome-ogp-0cf3e6504530401f7159a25fd447e597.png";